const SERIES = [
  { no: '壹', title: '从合伙到分家，内部群聊时间线还原始末', episode: '第 6 期', read: '2.4 万字', cat: '长文连载', pct: 78 },
  { no: '贰', title: '「停更的半个月」：回归首秀的每处配图细节', episode: '第 3 期', read: '1.1 万字', cat: '长文连载', pct: 46 },
  { no: '叁', title: '一次撤投引发的连锁：三个月内的三份声明', episode: '第 5 期', read: '1.8 万字', cat: '长文连载', pct: 64 }
];

const CHAPTERS = [
  { label: '上篇 · 矛盾的起点', done: true },
  { label: '中篇 · 聊天记录还原', done: true },
  { label: '下篇 · 删帖与改口', done: true },
  { label: '终篇 · 结局与留白', done: false }
];

export default function LongReadSeries() {
  return (
    <section id="long-read" className="bg-paper">
      <div className="mx-auto max-w-[1360px] px-4 py-10 md:px-6 md:py-14">
        <div className="mb-6 flex flex-wrap items-end justify-between gap-3 border-b-2 border-ink pb-3">
          <div>
            <div className="flex items-center gap-2">
              <i className="ri-book-open-line text-xl text-verm" />
              <h2 className="font-display text-xl font-black md:text-2xl">长文连载 · 细节全解析</h2>
            </div>
            <p className="mt-1 text-sm text-ink/55">适合想慢慢读的用户：一篇更数期，事件从头到尾不腰斩。</p>
          </div>
          <span className="rounded-full bg-gold-soft px-3 py-1 text-xs font-semibold text-gold">周更 · 已连载 14 期</span>
        </div>

        <div className="grid gap-5 lg:grid-cols-5">
          {/* 头部长文（连载进度 + 章节） */}
          <article className="lg:col-span-3">
            <div className="flex h-full flex-col bg-ink p-6 text-paper2 md:p-8">
              <div className="flex flex-wrap items-center gap-2">
                <span className="bg-verm px-2 py-1 text-[11px] font-bold tracking-widest">连载中 · 每周日更新</span>
                <span className="text-xs text-paper2/50">已更第 14 期 · 累计 6.7 万字</span>
              </div>
              <h3 className="font-display mt-4 text-xl font-black leading-snug md:text-2xl">
                万字拆解《背刺的一年》：一场合作从蜜月到撕破脸的全程记录
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-paper2/70">
                按日期重排几百条公开记录，配分账截图、聊天转写与删帖前后对比，逐月还原双方如何从"一起干"走到"各自发文"。
              </p>

              <div className="mt-5 space-y-2.5">
                {CHAPTERS.map((ch) => (
                  <div
                    key={ch.label}
                    className={`flex items-center gap-3 rounded-md border px-3 py-2.5 text-sm ${
                      ch.done ? 'border-paper2/15 bg-paper2/5' : 'border-dashed border-paper2/25 bg-paper2/5'
                    }`}
                  >
                    <span className={`h-2 w-2 rounded-full ${ch.done ? 'bg-gold' : 'bg-paper2/30'}`} />
                    <span className={ch.done ? 'font-medium text-paper2' : 'text-paper2/45'}>{ch.label}</span>
                    <span className="ml-auto text-xs text-paper2/40">{ch.done ? '已上' : '待更'}</span>
                  </div>
                ))}
              </div>

              <a
                href="#long-read"
                className="mt-6 flex items-center justify-center gap-1 bg-verm py-3 text-sm font-bold text-paper2 hover:bg-verm-dark"
              >
                从头读起 · 第 1 期 <i className="ri-arrow-right-line" />
              </a>
            </div>
          </article>

          {/* 其它连载 */}
          <div className="flex flex-col gap-5 lg:col-span-2">
            {SERIES.map((s) => (
              <article key={s.no} className="group flex flex-1 flex-col border border-line bg-paper2 p-5 transition-colors hover:border-verm/45 hover:bg-verm-wash">
                <div className="flex items-center gap-2 text-xs text-ink/45">
                  <span className="font-display text-lg font-black text-verm">{s.no}</span>
                  <span className="bg-band px-1.5 py-0.5 text-[11px] text-verm">{s.cat}</span>
                  <span className="ml-auto">{s.episode} · {s.read}</span>
                </div>
                <h3 className="mt-2.5 text-[15px] font-bold leading-snug group-hover:text-verm md:text-base">
                  <a href="#long-read" className="hover:text-verm">{s.title}</a>
                </h3>
                <div className="mt-3">
                  <div className="h-1.5 w-full bg-band">
                    <div className="h-1.5 bg-verm" style={{ width: `${s.pct}%` }} />
                  </div>
                  <div className="mt-1 flex justify-between text-[11px] text-ink/45">
                    <span>连载进度</span>
                    <span>{s.pct}%</span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}